import {Observable} from 'rxjs';

export interface Origin {
    id?: number;
    name: string;
    active?: boolean;
}

export abstract class OriginsData {
    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;
    abstract get(id: number): Observable<Origin>;
    abstract update(origin: Origin): Observable<Origin>;
    abstract create(origin: Origin): Observable<Origin>;
    abstract delete(origin: Origin): Observable<Origin>;
}

